// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_Xi8","cls2":"ReferenceEvaluationPage-cls2_Z2E ReferenceEvaluationPage-cls1_Xi8"};